import { jsx as _jsx } from "react/jsx-runtime";
import { HOC } from "../HOC";
import classNames from "classnames";
export const SelectEx = HOC((props) => {
    const { isError, className, ...rest } = props;
    return _jsx("select", { ...rest, className: classNames(className, { "validation-error": isError }) });
}, "blurOrChange");
